import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-bold text-gray-400 border-b pb-2" }, " Add to Shipping Cart ", -1)
const _hoisted_4 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-sm" }, "Inventory to Ship", -1)
const _hoisted_6 = { class: "flex-1 mt-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "whitespace-nowrap font-bold text-sm" }, "# of Rounds", -1)
const _hoisted_8 = { class: "border border-gray-400 rounded flex" }
const _hoisted_9 = { class: "flex-1 text-center" }
const _hoisted_10 = { class: "flex flex-row text-sm" }
const _hoisted_11 = { class: "flex-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "candidates" }, "Skip Confirmation", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/platform-fees",
    class: "text-indigo-600 hover:text-indigo-400 mr-1",
    target: "usae-fees"
  }, "View Fees")
], -1)
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "border-b pb-2 mb-3" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-bold text-gray-400 w-full" }, [
    /*#__PURE__*/_createTextVNode(" Uh Oh! You Don't Have Enough Rounds"),
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1)
const _hoisted_16 = { class: "opacity-50 text-sm" }
const _hoisted_17 = { class: "flex flex-row whitespace-nowrap space-x-2 mb-1 mt-5" }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { class: "flex flex-row border-b pb-2 mb-3" }
const _hoisted_20 = { class: "text-lg font-bold text-gray-400 w-full" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "opacity-50 text-sm" }, "You can continue browsing. When you’re ready, open your cart from the top right of this website.", -1)
const _hoisted_23 = { class: "flex flex-row whitespace-nowrap space-x-2 mb-1 mt-5" }
const _hoisted_24 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductMenu = _resolveComponent("ProductMenu")!
  const _component_ShipmentIcon = _resolveComponent("ShipmentIcon")!
  const _directive_autowidth = _resolveDirective("autowidth")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.hasEnoughRounds && !_ctx.roundsAddedToCart)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          (!_ctx.productId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_ProductMenu, {
                  onSelected: _ctx.onProductSelected,
                  commodityId: _ctx.commodityId
                }, null, 8, ["onSelected", "commodityId"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass([(!_ctx.productId && !_ctx.selectedProduct) || _ctx.isLoading ? 'pointer-events-none opacity-30' : ''])
          }, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.decrBox && _ctx.decrBox(...args))),
                  class: "inline-block cursor-pointer bg-slate-100 px-3 py-2 text-indigo-500 hover:bg-indigo-200 rounded-l"
                }, " -20 "),
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    class: "inline border-0 text-right w-16 p-0 my-2 focus:outline-none focus:border-none",
                    onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onInputBlur && _ctx.onInputBlur(...args))),
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rounds) = $event))
                  }, null, 544), [
                    [_directive_autowidth, { minWidth: `${_ctx.rounds.toString().length * 10}px` }],
                    [_vModelText, _ctx.rounds]
                  ])
                ]),
                _createElementVNode("div", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.incrBox && _ctx.incrBox(...args))),
                  class: "inline-block cursor-pointer bg-slate-100 px-3 py-2 text-indigo-500 hover:bg-indigo-200 rounded-r"
                }, " +20 ")
              ])
            ]),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addItemToCart && _ctx.addItemToCart(...args))),
              class: "mb-1 mt-5 w-full bg-indigo-500 hover:bg-indigo-600 text-white border px-5 py-2 rounded"
            }, " Add To Shipping Cart "),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  id: "candidates",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.skipConfirmation) = $event)),
                  name: "candidates",
                  type: "checkbox",
                  class: "h-4 w-4 mr-2 text-indigo-600 border-gray-300 rounded"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.skipConfirmation]
                ]),
                _hoisted_12
              ]),
              _hoisted_13
            ])
          ], 2)
        ]))
      : (!_ctx.hasEnoughRounds)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("p", _hoisted_16, "You need at least " + _toDisplayString(_ctx.minBoxSize) + " rounds to ship this product. That's the smallest box size. You only have " + _toDisplayString(_ctx.getRoundsOwned()) + ".", 1),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeOverlay && _ctx.closeOverlay(...args))),
                class: "w-full bg-white text-indigo-500 hover:text-indigo-800 hover:border-indigo-600 border border-slate-300 px-5 py-2 rounded"
              }, " Close Overlay ")
            ])
          ]))
        : (_ctx.roundsAddedToCart && !_ctx.skipConfirmation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("h3", _hoisted_20, [
                  _createTextVNode(" Yay! " + _toDisplayString(_ctx.roundsAddedToCart) + " Rounds Added", 1),
                  _hoisted_21,
                  _createTextVNode(" To Your Shipping Cart! ")
                ]),
                _createVNode(_component_ShipmentIcon, { totalRounds: _ctx.roundsAddedToCart }, null, 8, ["totalRounds"])
              ]),
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeOverlay && _ctx.closeOverlay(...args))),
                  class: "w-full bg-white text-indigo-500 hover:text-indigo-800 hover:border-indigo-600 border border-slate-300 px-5 py-2 rounded"
                }, " Close Overlay "),
                _createElementVNode("button", {
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openShippingCart && _ctx.openShippingCart(...args))),
                  class: "w-full bg-white text-indigo-500 hover:text-indigo-800 hover:border-indigo-600 border border-slate-300 px-5 py-2 rounded"
                }, " Open Shipping Cart ")
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_24, "You have no inventory to ship."))
  ]))
}